import { configureStore } from '@reduxjs/toolkit'
import userReducer from '../stores/userSlice'
import employeeReducer from '../stores/employeeSlice'
import projectReducer from '../stores/projectSlice'
import notificationReducer from '../stores/notificationSlice'
import loadingReducer from '../stores/loadingSlice'

export const store = configureStore({
  reducer: {
    user: userReducer,
    employees: employeeReducer,
    projects: projectReducer,
    notification:notificationReducer,
    loading: loadingReducer
  },
  devTools: process.env.NODE_ENV !== 'production',
})